export default __webpack_public_path__ + "static/shape-1-cd4304c35aed45d201667006ffb61344.svg";